import SceneLayerCanvasGeom from "./canvas-geom";

export default class SceneLayerWinter extends SceneLayerCanvasGeom {
	/**
	 * Informace ohledne entity ve scene.
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "SceneLayerWinter",
			type: "layer",
		};
	}
}
